<!--
 * @Author: liushuaibo liushuaibo@yangxuan.net
 * @Date: 2023-06-15 19:45:16
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-10 13:37:49
 * @FilePath: \seller.sviptrader.com\src\components\layout\components\funIntroduce\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<transition name="dialog-fade">
		<div class="upgradation-box" v-if="visible">
			<div class="content">
				<template v-if="isCarousel">
					<el-carousel height="490px" style="width: 100%" arrow="always" :autoplay="true" indicator-position="none">
						<el-carousel-item v-for="(item, index) in imgList" :key="index">
							<img :src="item.img" alt="" />
						</el-carousel-item>
					</el-carousel>
					<div class="close yx-color-white font-h4-regular">
						<span class="cursor-pointer mr-16" @click="notReminding" v-if="0">不再提醒</span>
						<span class="cursor-pointer" @click.stop="visible = false">关闭</span>
					</div>
				</template>
				<template v-else>
					<div class="flex-center">
						<slot name="introductionImg"></slot>
					</div>
					<div class="close yx-color-white font-h4-regular">
						<span class="cursor-pointer ml-16" @click.stop="visible = false">关闭</span>
					</div>
				</template>
			</div>
		</div>
	</transition>
</template>
<script>
export default {
	props: {
		//是否为轮播组件
		isCarousel: {
			type: Boolean,
			default: false,
		},
		//是否弹框打开
		isPopOpen: {
			type: Boolean,
			default: false,
		},
		//图片列表
		imgList: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			visible: false,
			active: 0,
			timer: null,
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
	},
};
</script>
<style lang="less" scoped>
.upgradation-box {
	z-index: 3017;
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: rgba(29, 33, 41, 0.6);
	.content {
		width: 960px;
		margin: 0 auto;
		margin-top: 15vh;
		display: flex;
		flex-direction: column;
		align-items: center;
		border-radius: 12px;
		position: relative;
		::v-deep .el-carousel__item {
			display: flex;
			justify-content: center;
		}
		::v-deep .el-carousel__arrow {
			border: 1px solid #fff;
		}
		.close {
			position: absolute;
			right: 0px;
			top: -36px;
		}
	}
}
</style>
